

module.exports = __webpack_require__.stylable.create(
    "proGallery340175762",
    {"classes":{"root":"proGallery340175762__root","customProGallery":"proGallery340175762__customProGallery"},"vars":{},"stVars":{"sliderArrowsColor":"\"fallback(color(--sliderArrowsColor), color(color-5))\"","m_sliderArrowsColor":"\"fallback(color(--m_sliderArrowsColor), color(color-5))\""},"keyframes":{}},
    "",
    1,
    "proGallery340175762",
    null
);
